import { Track } from './Track';
import { TrackEventPropsType } from './TrackingFunctions.d';

type TrackPropsType = TrackEventPropsType & {
	screen: string;
	action: string;
};

type ErrorObj = {
	error: unknown;
};

function isErrPropExist(obj: unknown): obj is ErrorObj {
	return typeof obj === 'object' && obj !== null && 'error' in obj;
}

function hasError(obj: unknown): obj is ErrorObj {
	return isErrPropExist(obj) && !!obj.error;
}

export function getError(e: unknown) {
	return e instanceof Error
		? { message: e.message || '', stack: e.stack || '' }
		: e;
}

export async function TrackWithEventError({
	trackCb,
	screen,
	action,
	campaignId = '',
	contentId = '',
	ratAccountId = '',
	ratServiceType = '',
	isMobile = false,
	message = '',
}: TrackPropsType) {
	const opts = {
		screen,
		campaignId,
		contentId,
		ratAccountId,
		ratServiceType,
		isMobile,
	};

	try {
		const [ratResult, cbResult] = await Promise.all([
			Track({ ...opts, action, message }),
			trackCb(),
		]);

		if (hasError(cbResult)) {
			const ratTrackErrResult = await Track({
				...opts,
				action: `${action}_ERROR`,
				message: cbResult,
			});

			return ratTrackErrResult;
		}

		return ratResult;
	} catch (e) {
		const result = await Track({
			...opts,
			action: `${action}_ERROR`,
			message: getError(e),
		});

		return result;
	}
}
